import * as React from 'react';
import { Form, Field } from 'formik';
import * as Yup from 'yup';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';


const LocationSchema = Yup.object().shape({
  name: Yup.string()
           .required('Required'),
  street1: Yup.string(),
  street2: Yup.string(),
  city: Yup.string(),
  state: Yup.string(),
  zipcode: Yup.string(),
  lastname: Yup.string(),
});


const LocationForm = (props) => {
  const { initialValues, onSubmit } = props;

  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={(data) => onSubmit(LocationSchema.cast(data))}
      validationSchema={LocationSchema}
      render={() => {
        return (
          <Form className="form__cont">
            <Field
              name="name"
              label="Name"
              type="text"
              component={Input}
              className="input"
            />
            <Field
              name="street1"
              label="Street"
              type="text"
              component={Input}
              className="input"
            />
            <Field
              name="street2"
              label="Street 2"
              type="text"
              component={Input}
              className="input"
            />
            <Field
              name="city"
              label="City"
              type="text"
              component={Input}
              className="input"
            />
            <Field
              name="state"
              label="State"
              type="text"
              component={Input}
              className="input"
            />
            <Field
              name="zipcode"
              label="Zip"
              type="text"
              component={Input}
              className="input"
            />

            <button className="btn btn--prim btn--lg" type="submit">
              Submit
            </button>
          </Form>
        );
      }}
    />
  );
};

export default LocationForm;
